import { Lock } from '@mui/icons-material'

import BaseStatusIcon from '../BaseStatusIcon'

const SessionLockedStatusIcon = () => {
  return <BaseStatusIcon title='Locked' icon={Lock} />
}

export default SessionLockedStatusIcon
